<div
  #scroller
  class="grid-container flex flex-row"
  data-test-id="schedule-calendar-scroller"
  [style.height.px]="scrollerHeight"
  (scroll)="onScroll()"
>
  <div class="gutter">
    <div class="gutter-header"></div>
    <div class="gutter-body" [style.height.px]="height">
      @for (hour of hourLabels; track hour.label) {
        <span class="hour-label" [style.top.px]="hour.top">
          {{ hour.label }}
        </span>
      }
      @if (nowLabel(); as now) {
        <span
          class="hour-label now-label"
          data-test-id="schedule-calendar-now-label"
          [style.top.px]="now.top"
        >
          {{ now.label }}
        </span>
      }
    </div>
  </div>
  <div
    class="days"
    [style.grid-template-columns]="`repeat(${days().length}, minmax(0, 1fr))`"
  >
    @for (day of days(); track day.date) {
      <app-schedule-calendar-day
        [day]="day"
        [nowMinutes]="nowMinutes()"
        [content]="dayContent()?.templateRef"
      />
    }
  </div>
</div>
@if (scrollHints().earlier; as earlier) {
  <button
    type="button"
    class="scroll-hint earlier flex flex-row items-center gap-1"
    data-test-id="schedule-calendar-earlier-times"
    (click)="scrollTo(earlier.top)"
  >
    <mat-icon>arrow_upward</mat-icon>
    {{ earlier.label }}
  </button>
}
@if (scrollHints().later; as later) {
  <button
    type="button"
    class="scroll-hint later flex flex-row items-center gap-1"
    data-test-id="schedule-calendar-later-times"
    (click)="scrollTo(later.top)"
  >
    <mat-icon>arrow_downward</mat-icon>
    {{ later.label }}
  </button>
}
